/**
 *
 * Organizations/Show/Events/SubTable
 *
 */

import React, { memo } from 'react'

// Libraries
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

// Components
import ReactTable, { dateTimeCell, dateAccessor } from 'components/ReactTable'

function EventsTable({ events, ...props }) {
	const columns = [
		{
			Header: 'Event',
			id: 'venue',
			accessor: (e) => e.venue,
			Cell: ({ row: { original: e } }) => (
				<div style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
					<Link to={`/campaigns/${e.campaign_id}/events/${e.id}`} className="table-link" target="_blank">
						{e.venue}
					</Link>
				</div>
			),
			width: 220,
			disableFilterBy: true,
		},
		{
			Header: 'Start time',
			id: 'start_time',
			accessor: dateAccessor('start_time'),
			Cell: dateTimeCell,
			disableFilterBy: true,
			sortType: 'datetime',
		},
		{
			Header: 'Registrations',
			id: 'registrations_count',
			accessor: 'registrations_count',
			width: 100,
			disableFilterBy: true,
			className: 'text-center',
		},
		{
			Header: 'Confirmed',
			id: 'confirmed',
			accessor: 'confirmation_confirmed_count',
			width: 100,
			disableFilterBy: true,
			className: 'text-center',
		},
		{
			Header: 'Attended',
			id: 'attended',
			accessor: 'attended_count',
			width: 100,
			disableFilterBy: true,
			className: 'text-center',
		},
		{
			Header: 'Capacity',
			id: 'capacity',
			accessor: 'capacity',
			width: 100,
			disableFilterBy: true,
			className: 'text-center',
		},
	]

	return (
		<div className="mb-2">
			<ReactTable data={events} columns={columns} {...props} />
		</div>
	)
}

EventsTable.propTypes = {
	events: PropTypes.array,
}

export default memo(EventsTable)
